export default __webpack_public_path__ + "static/media/Dysautonomia-Inspired-Dragonfly-Necklace.279c08f0.jpg";